import PersonalInformationModelPopup from "components/modelpopup/PersonalInformationModelPopup";
import PersonalInfoModal from "components/modelpopup/personalInfoModal";
import { useEffect,useLayoutEffect,useMemo,useRef,useState } from "react";
import { Link,useLocation } from "react-router-dom";
import { Bounce,toast } from "react-toastify";

import { deleteAddressApi,getOrgChartPublicApi } from "api/services/employee";
import Image from "components/Image";
import DeleteModal from "components/modelpopup/DeleteModal";
import AddressModal from "components/modelpopup/emergencyContactModal";
import { useSelector } from "react-redux";
import { toTitleCase } from "utils/common";
import { EmployeeAssets } from "./EmployeeAssets";
import { EmployeeLeave } from "./EmployeeLeave";
import { EmploymentDetails,ListItem } from "./EmployeeProfileContent";
import AccountSettings from "./accountSettings";
import EmpDocuments from "./employeeDocument";
import EmpExpenses from "./employeeExpenses";
import EmpUniforms from "./employeeUniforms";
const ProfileTab = ({
  userData,
  userSalaryData,
  addressData,
  addressLoading,
  fetchAddresses,
  fetchDetail,
  allowedEmployeeIds = [],
  showOrgChart = false,
}) => {
  const {
    user,
    userLoading
  } = useSelector((state) => state.user);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useLayoutEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const [personalInfoData, setPersonalInfo] = useState([]) 
  const [bankInfoData, setBankInfoData] = useState([])
  const [addressModal, setAddressModal] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState("")
  const [deleteModal, setDeleteModal] = useState(false);
  const [orgChartData, setOrgChartData] = useState(null);
  const [orgChartLoading, setOrgChartLoading] = useState(false);
  const [expandedIds, setExpandedIds] = useState(new Set());
  const [orgDirection, setOrgDirection] = useState("horizontal"); // "horizontal" | "vertical"
  const [zoomLevel, setZoomLevel] = useState(1);
  const chartContainerRef = useRef(null);
  const rootNodeRef = useRef(null);
  const zoomContainerRef = useRef(null);
  const location = useLocation();
  const basePath = location.pathname.includes("/company-directory") ? "/company-directory" : "/employees";


  const [personalInfoModal, setPersonalInfoModal] = useState(false);


  console.log(userData, user, "UUUU")
  useEffect(()=>{
   const personal =  [
      { id: 3, title: "Phone", text: userData?.contact?.mobile_no, type:"tel" },
      { id: 4, title: "Email", text: userData?.contact?.private_email, type:"mailto" },
      { id: 5, title: "Address", text: [userData?.contact?.address_1, userData?.contact?.address_2, userData?.contact?.city]
            .map(item => item?.trim()).filter(Boolean).join(", ")}, 
      { id: 7, title: "Nationality", text: userData?.nationality?.name },
      { id: 9, title: "Marital status", text: toTitleCase(userData?.marital_status||"") },
      { id: 11, title: "No. of children", text: userData?.no_of_dependent},
      { id: 12, title: "Blood group", text: userData?.blood_group  },
    ].filter(item => item.text) // Only show items with data
    setPersonalInfo(personal)
    const bank = [
      { id: 1, title: "Bank name", text: userData?.bank_detail?.bank_branch_name },
      { id: 3, title: "IBAN", text: userData?.bank_detail?.iban},
    ].filter(item => item.text) // Only show items with data
    setBankInfoData(bank)

  },[userData])

  // Fetch organization chart for the current employee (optional)
  useEffect(() => {
    if (!showOrgChart) return;
    if (!userData?.id) return;
    const companyId =
      userData?.employment?.company?.id ??
      userData?.company?.id ??
      userData?.company_id ??
      userData?.employment?.company_user?.company?.id ??
      user?.company?.id ??
      user?.company_id ??
      1; // Default to 1 if not found

    setOrgChartLoading(true);
    
    // New public endpoint - only needs company parameter
    const params = {
      company: companyId,
    };

    // Helper function to find employee node in the tree
    const findEmployeeInTree = (nodes, employeeId) => {
      for (const node of nodes) {
        if (node.id === employeeId) {
          return node;
        }
        if (node.children && node.children.length > 0) {
          const found = findEmployeeInTree(node.children, employeeId);
          if (found) return found;
        }
      }
      return null;
    };

    getOrgChartPublicApi(params)
      .then((res) => {
        const results = res.data?.results || [];
        // Find the current employee in the results
        const employeeNode = findEmployeeInTree(results, userData.id);
        
        if (employeeNode) {
          setOrgChartData(employeeNode);
          // By default, nodes are collapsed (empty Set)
          setExpandedIds(new Set());
        } else {
          // If employee not found, create a minimal node from userData
          setOrgChartData({
            id: userData.id,
            name: [userData.first_name, userData.last_name].filter(Boolean).join(" ") || userData.name,
            emp_code: userData.emp_code || userData.emp_no,
            title: userData.employment?.position?.name || userData.title,
            department: userData.employment?.department?.name || userData.department?.name,
            profile_image: userData.profile_image,
            manager_id: userData?.employment?.report_to?.id,
            children: [],
          });
          // By default, nodes are collapsed (empty Set)
          setExpandedIds(new Set());
        }
      })
      .catch((err) => {
        console.error("Error fetching org chart", err);
        setOrgChartData(null);
      })
      .finally(() => setOrgChartLoading(false));

    // OLD ENDPOINT CODE - KEPT HIDDEN FOR REFERENCE
    // const oldParams = {
    //   root_user_id: userData.id,
    //   depth: 8,
    //   include_line_manager: true,
    //   ...(companyId ? { company: companyId } : {}),
    // };
    // getOrgChartApi(oldParams)
    //   .then((res) => {
    //     setOrgChartData(res.data?.results?.[0] || null);
    //     const managerId = userData?.employment?.report_to?.id;
    //     setExpandedIds(new Set(managerId ? [managerId, userData.id] : [userData.id])); // expand root (and manager if exists)
    //   })
    //   .catch((err) => {
    //     console.error("Error fetching org chart", err);
    //     setOrgChartData(null);
    //   })
    //   .finally(() => setOrgChartLoading(false));
  }, [userData?.id, user, showOrgChart]);

  useEffect(() => {
    if (!zoomContainerRef.current || !rootNodeRef.current) return;
    if (orgDirection !== "horizontal") return;
    const container = zoomContainerRef.current;
    const root = rootNodeRef.current;
    // Calculate scroll position to center the root node
    const containerRect = container.getBoundingClientRect();
    const rootRect = root.getBoundingClientRect();
    const scrollLeft = rootRect.left - containerRect.left + container.scrollLeft - (containerRect.width / 2) + (rootRect.width / 2);
    container.scrollTo({ left: Math.max(scrollLeft, 0), behavior: "smooth" });
  }, [orgChartData, orgDirection, zoomLevel]);

  const displayChartData = useMemo(() => {
    if (!orgChartData) return null;
    const manager = userData?.employment?.report_to;
    if (manager?.id) {
      return {
        id: manager.id,
        name: [manager.first_name, manager.last_name].filter(Boolean).join(" "),
        emp_code: manager.emp_code || manager.emp_no || manager.empNo,
        title: manager.position?.name,
        department: manager.department?.name,
        profile_image: manager.profile_image,
        children: [orgChartData],
      };
    }
    return orgChartData;
  }, [orgChartData, userData?.employment?.report_to]);
  
  // const personalInfoData = [
  //   { id: 1, title: "Passport No.", text: "9876543210" },
  //   { id: 2, title: "Passport Exp Date.", text: "9876543210" },
  //   { id: 3, title: "Tel", text: "9876543210" },
  //   { id: 4, title: "Nationality", text: "Indian" },
  //   { id: 5, title: "Religion", text: "Christian" },
  //   { id: 6, title: "Marital status", text: "Married" },
  //   { id: 7, title: "Employment of spouse", text: "No" },
  //   { id: 8, title: "No. of children", text: "2" },
  // ];

  const primaryContactData = [
    { id: 1, title: "Name", text: "" },
    { id: 2, title: "Relationship", text: "" },
    { id: 3, title: "Phone", text: "" },
  ];

  const secondaryContactData = [
    { id: 1, title: "Name", text: "" },
    { id: 2, title: "Relationship", text: "" },
    { id: 3, title: "Phone", text: "" },
  ];
  // const bankInfoData = [
  //   { id: 1, title: "Bank name", text: "ICICI Bank" },
  //   { id: 2, title: "Bank account No.", text: "159843014641" },
  //   { id: 3, title: "IFSC Code", text: "ICI24504" },
  //   { id: 4, title: "PAN No", text: "TC000Y56" },
  // ];
  const familyInfoData = [
    {
      id: 1,
      name: "Leo",
      relationship: "Brother",
      dob: "Feb 16th, 2019",
      phone: "9876543210",
    },
  ];

  const educationData = [
    {
      id: 1,
      name: "International College of Arts and Science (UG)",
      description: "Bsc Computer Science",
      time: "2020 - 2023",
    },
    {
      id: 2,
      name: "International College of Arts and Science (PG)",
      description: "Msc Computer Science",
      time: "2021 - 2023",
    },
    // Add more education info data as needed
  ];
  const experienceData = [
    {
      id: 1,
      name: "Web Designer at Zen Corporation",
      time: "Jan 2023 - Present (5 years 2 months)",
    },
    {
      id: 2,
      name: "Web Designer at Ron-tech",
      time: "Jan 2023 - Present (5 years 2 months)",
    },
    {
      id: 3,
      name: "Web Designer at Dalt Technology",
      time: "2023 2023 - Present (5 years 2 months)",
    },
    // Add more experience info data as needed
  ];


  const deleteAddress = () => {
    deleteAddressApi(selectedAddress?.id).then(res=>{
      toast.success('Contact deleted!', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
          });
          fetchAddresses()
          setDeleteModal(false)
    }).catch(err=>{
      toast.error('Error deleting contact!', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
        });
    })
  }

  const getInitials = (name = "") => {
    return name
      .split(" ")
      .map((n) => n[0])
      .join("")
      .slice(0, 2)
      .toUpperCase();
  };

  const levelColors = [
    "#ffffff",
    "#f8fafc",
    "#f1f5f9",
    "#e0f2fe",
    "#eef2ff",
    "#ecfdf3",
  ];

  const OrgChartNode = ({ node, level = 0, direction = orgDirection }) => {
    if (!node) return null;
    const childCount = node.children?.length || 0;
    const isExpanded = expandedIds.has(node.id);
    const cardColor = levelColors[level % levelColors.length];

    const toggleExpand = () => {
      setExpandedIds((prev) => {
        const next = new Set(prev);
        if (next.has(node.id)) {
          next.delete(node.id);
        } else {
          next.add(node.id);
        }
        return next;
      });
    };

    return (
      <div className="org-node">
        <div className="org-card" style={{ background: cardColor }}>
          <div className="org-avatar">
            {node.profile_image ? (
              <Image
                src={node.profile_image}
                type="user"
                alt={node.name}
                style={{ width: "44px", height: "44px", borderRadius: "50%", objectFit: "cover" }}
              />
            ) : (
              <div className="org-placeholder">{getInitials(node.name)}</div>
            )}
          </div>
          <div className="org-meta">
            {allowedEmployeeIds.includes(node.id) ? (
              <Link
                to={`${basePath}/${node.id}`}
                className="org-name"
                style={{ color: "rgb(211, 0, 26)", textDecoration: "none" }}
              >
                {node.name}
              </Link>
            ) : (
              <div className="org-name" style={{ color: "#111827" }}>{node.name}</div>
            )}
            {node.emp_code && <div className="org-code">{node.emp_code}</div>}
            {node.title && <div className="org-title">{node.title}</div>}
            {node.department && <div className="org-dept">{node.department}</div>}
          </div>
          {childCount > 0 && (
            <button
              type="button"
              className="org-toggle"
              onClick={toggleExpand}
              aria-label={isExpanded ? "Collapse reports" : "Expand reports"}
            >
              <i className={`las ${isExpanded ? "la-minus" : "la-plus"}`} />
              <span className="org-count">{childCount}</span>
            </button>
          )}
        </div>
        {childCount > 0 && isExpanded && (
          <div className={`org-children ${direction === "vertical" ? "vertical" : ""}`}>
            {node.children.map((child) => (
              <OrgChartNode key={child.id} node={child} level={level + 1} direction={direction} />
            ))}
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      <div className="tab-content">
        <div
          id="emp_profile"
          className="pro-overview tab-pane fade show active"
          style={{ padding: isMobile ? "8px 0 160px 0" : "12px" }}
        >
          <div className="row g-3" style={isMobile ? { marginLeft: "0", marginRight: "0" } : {}}>
            <div className={isMobile ? "col-12" : "col-md-6 d-flex"}>
              <div className="card shadow-sm profile-box flex-fill" style={{ 
                borderRadius: "8px", 
                border: "1px solid #e5e7eb",
                background: "linear-gradient(to bottom, #ffffff 0%, #fef2f2 100%)",
                marginLeft: isMobile ? "8px" : "0px",
                marginRight: isMobile ? "8px" : "0px",
                marginBottom: isMobile ? "12px" : "0",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
              }}>
                <div className="card-body" style={{ padding: isMobile ? "12px" : "16px" }}>
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <h3 className="card-title mb-0" style={{ 
                      fontSize: isMobile ? "15px" : "16px",
                      fontWeight: "600",
                      color: "#1f2937"
                    }}>
                      Personal Information
                    </h3>
                    {(user?.id == userData.id || user?.role?.access_scope == "all") && (
                      <button
                        type="button"
                        onClick={()=> setPersonalInfoModal(true)}
                        style={{
                          width: "32px",
                          height: "32px",
                          borderRadius: "8px",
                          background: "linear-gradient(135deg, rgb(211, 0, 26) 0%, #f43b48 50%, #fc133d 100%)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "#ffffff",
                          border: "none",
                          boxShadow: "0 2px 8px rgba(211, 0, 26, 0.2)",
                          cursor: "pointer"
                        }}
                      >
                        <i className="fa fa-pencil" style={{ fontSize: "12px" }} />
                      </button>
                    )}
                  </div>
                  <ul className="personal-info" style={{ listStyle: "none", padding: 0, margin: 0 }}>
                    {personalInfoData.map((item, index) => (
                      <ListItem
                        id={item.id}
                        key={index}
                        title={item.title}
                        type={item.type}
                        text={item.text}
                        isMobile={isMobile}
                      />
                    ))}
                  </ul>
                </div>
              </div>
            </div>
            <div className={isMobile ? "col-12" : "col-md-6 d-flex"}>
              <div className="card shadow-sm profile-box flex-fill" style={{ 
                borderRadius: "8px", 
                border: "1px solid #e5e7eb",
                background: "linear-gradient(to bottom, #ffffff 0%, #fef2f2 100%)",
                marginLeft: isMobile ? "8px" : "0px",
                marginRight: isMobile ? "8px" : "0px",
                marginBottom: isMobile ? "12px" : "0",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
              }}>
                <div className="card-body" style={{ 
                  padding: isMobile ? "12px" : "16px",
                  maxHeight: isMobile ? "none" : "400px",
                  overflowY: isMobile ? "visible" : "auto"
                }}>
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <h3 className="card-title mb-0" style={{ 
                      fontSize: isMobile ? "15px" : "16px",
                      fontWeight: "600",
                      color: "#1f2937"
                    }}>
                      Emergency Contact
                    </h3>
                    {userData?.id === user?.id && (
                      <button
                        type="button"
                        onClick={()=>setAddressModal(true)}
                        style={{
                          width: "32px",
                          height: "32px",
                          borderRadius: "8px",
                          background: "linear-gradient(135deg, rgb(211, 0, 26) 0%, #f43b48 50%, #fc133d 100%)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "#ffffff",
                          border: "none",
                          boxShadow: "0 2px 8px rgba(211, 0, 26, 0.2)",
                          cursor: "pointer"
                        }}
                      >
                        <i className="fa fa-plus" style={{ fontSize: "12px" }} />
                      </button>
                    )}
                  </div>
                  {addressLoading ? (
                    <div className="text-center" style={{ padding: "20px" }}>
                      <div className="spinner-border text-primary" role="status"></div>
                    </div>
                  ) : addressData.length === 0 ? (
                    <div style={{
                      padding: "40px 20px",
                      textAlign: "center",
                      color: "#9ca3af"
                    }}>
                      <i className="las la-address-book" style={{ fontSize: "48px", marginBottom: "12px", display: "block" }}></i>
                      <p style={{ margin: 0, fontSize: "14px" }}>No emergency contacts found</p>
                    </div>
                  ) : (
                    addressData.map((address, index) => (
                      <div 
                        key={index} 
                        style={{
                          padding: isMobile ? "12px" : "12px",
                          marginBottom: index < addressData.length - 1 ? "12px" : "0",
                          background: "#ffffff",
                          borderRadius: "8px",
                          border: "1px solid #e5e7eb",
                          position: "relative"
                        }}
                      >
                        {userData?.id === user?.id && (
                          <div style={{
                            position: "absolute",
                            top: "12px",
                            right: "12px",
                            display: "flex",
                            gap: "8px"
                          }}>
                            <button
                              type="button"
                              onClick={()=>{
                                setSelectedAddress(address)
                                setAddressModal(true)
                              }}
                              style={{
                                width: "28px",
                                height: "28px",
                                borderRadius: "6px",
                                background: "#f3f4f6",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "#6b7280",
                                border: "none"
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.background = "#e5e7eb";
                                e.currentTarget.style.color = "#1f2937";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.background = "#f3f4f6";
                                e.currentTarget.style.color = "#6b7280";
                              }}
                            >
                              <i className="fa fa-pencil" style={{ fontSize: "11px" }} />
                            </button>
                            <button
                              type="button"
                              onClick={()=>{
                                setSelectedAddress(address)
                                setDeleteModal(true)
                              }}
                              style={{
                                width: "28px",
                                height: "28px",
                                borderRadius: "6px",
                                background: "#fee2e2",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "#dc2626",
                                border: "none"
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.background = "#fecaca";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.background = "#fee2e2";
                              }}
                            >
                              <i className="fa fa-trash" style={{ fontSize: "11px" }} />
                            </button>
                          </div>
                        )}
                        <div style={{ paddingRight: userData?.id === user?.id ? "50px" : "0" }}>
                          {address.name && (
                            <div style={{ marginBottom: "10px" }}>
                              <div style={{ fontSize: "11px", color: "#9ca3af", marginBottom: "4px" }}>Name</div>
                              <div style={{ fontSize: "14px", fontWeight: "600", color: "#1f2937" }}>{address.name}</div>
                            </div>
                          )}
                          {([address.address_1, address.address_2].filter(Boolean).length > 0) && (
                            <div style={{ marginBottom: "10px" }}>
                              <div style={{ fontSize: "11px", color: "#9ca3af", marginBottom: "4px" }}>Address</div>
                              <div style={{ fontSize: "13px", color: "#374151" }}>
                                {[address.address_1, address.address_2].filter(Boolean).join(", ")}
                              </div>
                            </div>
                          )}
                          {(address.city || address.country?.name) && (
                            <div className="row g-2" style={{ marginBottom: "10px" }}>
                              {address.city && (
                                <div className="col-6">
                                  <div style={{ fontSize: "11px", color: "#9ca3af", marginBottom: "4px" }}>City</div>
                                  <div style={{ fontSize: "13px", color: "#374151" }}>{address.city}</div>
                                </div>
                              )}
                              {address.country?.name && (
                                <div className="col-6">
                                  <div style={{ fontSize: "11px", color: "#9ca3af", marginBottom: "4px" }}>Country</div>
                                  <div style={{ fontSize: "13px", color: "#374151" }}>{address.country.name}</div>
                                </div>
                              )}
                            </div>
                          )}
                          {(address.emergency_contact_name || address.emergency_contact_number || address.emergency_contact_number_2) && (
                            <div style={{ marginTop: "10px", paddingTop: "10px", borderTop: "1px solid #e5e7eb" }}>
                              <div style={{ fontSize: "11px", color: "#9ca3af", marginBottom: "8px", fontWeight: "600" }}>Emergency Contact</div>
                              {address.emergency_contact_name && (
                                <div style={{ marginBottom: "8px" }}>
                                  <div style={{ fontSize: "11px", color: "#9ca3af", marginBottom: "4px" }}>Contact Name</div>
                                  <div style={{ fontSize: "13px", color: "#374151" }}>{address.emergency_contact_name}</div>
                                </div>
                              )}
                              {(address.emergency_contact_number || address.emergency_contact_number_2) && (
                                <div className="row g-2">
                                  {address.emergency_contact_number && (
                                    <div className="col-6">
                                      <div style={{ fontSize: "11px", color: "#9ca3af", marginBottom: "4px" }}>Contact Number</div>
                                      <a 
                                        href={`tel:${address.emergency_contact_number}`} 
                                        style={{ 
                                          fontSize: "13px",
                                          color: "rgb(211, 0, 26)",
                                          textDecoration: "none",
                                          fontWeight: "500"
                                        }}
                                      >
                                        {address.emergency_contact_number}
                                      </a>
                                    </div>
                                  )}
                                  {address.emergency_contact_number_2 && (
                                    <div className="col-6">
                                      <div style={{ fontSize: "11px", color: "#9ca3af", marginBottom: "4px" }}>Home Number</div>
                                      <a 
                                        href={`tel:${address.emergency_contact_number_2}`} 
                                        style={{ 
                                          fontSize: "13px",
                                          color: "rgb(211, 0, 26)",
                                          textDecoration: "none",
                                          fontWeight: "500"
                                        }}
                                      >
                                        {address.emergency_contact_number_2}
                                      </a>
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    ))
                  )}

                  {/* <h5 className="section-title">Primary</h5>
                  <ul className="personal-info">
                    {primaryContactData.map((item, index) => (
                      <ListItem
                        id={item.id}
                        key={index}
                        title={item.title}
                        text={item.text}
                      />
                    ))}
                  </ul>
                  <hr />
                  <h5 className="section-title">Secondary</h5>
                  <ul className="personal-info">
                    {secondaryContactData.map((item, index) => (
                      <ListItem
                        id={item.id}
                        key={index}
                        title={item.title}
                        text={item.text}
                      />
                    ))}
                  </ul> */}
                </div>
              </div>
            </div>
          </div>
          <div className="row g-3" style={isMobile ? { marginLeft: "0", marginRight: "0", marginTop: "12px", marginBottom: "30px" } : { marginTop: "12px" }}>
            <div className={isMobile ? "col-12" : "col-md-6 d-flex"}>
              <div className="card shadow-sm profile-box flex-fill" style={{ 
                borderRadius: "8px", 
                border: "1px solid #e5e7eb",
                background: "linear-gradient(to bottom, #ffffff 0%, #fef2f2 100%)",
                marginLeft: isMobile ? "8px" : "0",
                marginRight: isMobile ? "8px" : "0",
                marginBottom: isMobile ? "30px" : "0",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
              }}>
                <div className="card-body" style={{ padding: isMobile ? "16px 12px 12px 12px" : "16px" }}>
                  <h3 className="card-title mb-2" style={{ 
                    fontSize: isMobile ? "15px" : "16px",
                    fontWeight: "600",
                    color: "#1f2937"
                  }}>
                    Bank Information
                  </h3>
                  <ul className="personal-info" style={{ listStyle: "none", padding: 0, margin: 0 }}>
                    {bankInfoData.map((item, index) => (
                      <ListItem
                        id={item.id}
                        key={index}
                        title={item.title}
                        text={item.text}
                        isMobile={isMobile}
                      />
                    ))}
                  </ul>
                </div>
              </div>
            </div>
            {/* <div className="col-md-6 d-flex">
              <div className="card profile-box flex-fill">
                <div className="card-body">
                  <h3 className="card-title">
                    Family Informations{" "}
                   
                  </h3>
                  <div className="table-responsive">
                    <table className="table table-nowrap">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Relationship</th>
                          <th>Date of Birth</th>
                          <th>Phone</th>
                          <th />
                        </tr>
                      </thead>
                      <tbody>
                        {familyInfoData.map((item) => (
                          <tr key={item.id}>
                            <td>{item.name}</td>
                            <td>{item.relationship}</td>
                            <td>{item.dob}</td>
                            <td>{item.phone}</td>
                            <td className="text-end">
                              <div className="dropdown dropdown-action">
                                <button
                                  type="button"
                                  aria-expanded="false"
                                  data-bs-toggle="dropdown"
                                  className="action-icon dropdown-toggle"
                                  style={{ border: "none", background: "transparent" }}
                                >
                                  <i className="material-icons">more_vert</i>
                                </button>
                                <div className="dropdown-menu dropdown-menu-right">
                            <button type="button" className="dropdown-item" style={{ border: "none", background: "transparent" }}>
                              <i className="fa fa-pencil m-r-5" /> Edit
                            </button>
                            <button type="button" className="dropdown-item" style={{ border: "none", background: "transparent" }}>
                              <i className="fa fa-trash m-r-5" /> Delete
                            </button>
                                </div>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
          {/* <div className="row">
            <div className="col-md-6 d-flex">
              <div className="card profile-box flex-fill">
                <div className="card-body">
                  <h3 className="card-title">
                    Education Informations{" "}
                    <Link
                      to="#"
                      className="edit-icon"
                      data-bs-toggle="modal"
                      data-bs-target="#education_info"
                    >
                      <i className="fa fa-pencil" />
                    </Link>
                  </h3>
                  <div className="experience-box">
                    <ul className="experience-list">
                      {educationData.map((item) => (
                        <li key={item.id}>
                          <div className="experience-user">
                            <div className="before-circle" />
                          </div>
                          <div className="experience-content">
                            <div className="timeline-content">
                              <Link to="/" className="name">
                                {item.name}
                              </Link>
                              <div>{item.description}</div>
                              <span className="time">{item.time}</span>
                            </div>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6 d-flex">
              <div className="card profile-box flex-fill">
                <div className="card-body">
                  <h3 className="card-title">
                    Experience{" "}
                    <Link
                      to="#"
                      className="edit-icon"
                      data-bs-toggle="modal"
                      data-bs-target="#experience_info"
                    >
                      <i className="fa fa-pencil" />
                    </Link>
                  </h3>
                  <div className="experience-box">
                    <ul className="experience-list">
                      {experienceData.map((item) => (
                        <li key={item.id}>
                          <div className="experience-user">
                            <div className="before-circle" />
                          </div>
                          <div className="experience-content">
                            <div className="timeline-content">
                              <Link to="/" className="name">
                                {item.name}
                              </Link>
                              <span className="time">{item.time}</span>
                            </div>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
        </div>
        <EmploymentDetails userData={userData} userSalaryData={userSalaryData} fetchInfo={fetchDetail}/>

        {showOrgChart && (
        <div
          id="emp_org_chart"
          className="tab-pane fade"
          style={{ padding: isMobile ? "8px 0 160px 0" : "12px 0 80px 0" }}
        >
          <style>{`
            .org-node {
              display: flex;
              flex-direction: column;
              align-items: center;
              gap: 8px;
              padding: 8px;
              min-width: 220px;
            }
            .org-card {
              display: flex;
              align-items: center;
              gap: 12px;
              background: #ffffff;
              border: 1px solid #e5e7eb;
              border-radius: 10px;
              padding: 12px 14px;
              box-shadow: 0 2px 8px rgba(0,0,0,0.08);
              width: 260px;
              min-height: 130px;
              position: relative;
              overflow: hidden;
            }
            .org-avatar {
              width: 48px;
              height: 48px;
              border-radius: 50%;
              overflow: hidden;
              background: #f3f4f6;
              display: flex;
              align-items: center;
              justify-content: center;
              font-weight: 700;
              color: #6b7280;
              flex-shrink: 0;
            }
            .org-placeholder {
              width: 100%;
              height: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
              background: #fee2e2;
              color: #b91c1c;
              font-weight: 700;
            }
            .org-meta {
              display: flex;
              flex-direction: column;
              gap: 2px;
              flex: 1;
            }
            .org-name {
              font-weight: 600;
              color: #111827;
              font-size: 14px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              width: 100%;
            }
            .org-code {
              font-size: 12px;
              color: #1f2937;
              font-weight: 600;
              white-space: nowrap;
            }
            .org-toggle {
              position: absolute;
              top: 8px;
              right: 8px;
              border: 1px solid #e5e7eb;
              background: #f9fafb;
              border-radius: 10px;
              width: 32px;
              height: 32px;
              font-size: 14px;
              color: #1f2937;
              display: inline-flex;
              align-items: center;
              justify-content: center;
              cursor: pointer;
              transition: all 0.15s ease;
            }
            .org-toggle:hover {
              background: #eef2ff;
              border-color: #c7d2fe;
            }
            .org-count {
              position: absolute;
              top: -6px;
              right: -6px;
              background: #ef4444;
              color: #ffffff;
              border-radius: 999px;
              font-size: 10px;
              padding: 2px 5px;
              line-height: 1;
              min-width: 18px;
              text-align: center;
            }
            .org-title {
              font-size: 12px;
              color: #6b7280;
              word-break: break-word;
              white-space: normal;
            }
            .org-dept {
              font-size: 12px;
              color: #9ca3af;
              word-break: break-word;
              white-space: normal;
            }
            .org-children {
              display: flex;
              flex-wrap: nowrap;
              gap: 16px;
              margin-top: 16px;
              padding: 24px 24px 8px 24px;
              justify-content: center;
              position: relative;
              overflow-x: auto;
              overflow-y: visible;
            }
            .org-children::before {
              content: "";
              position: absolute;
              top: 0;
              left: 50%;
              width: 1px;
              height: 16px;
              background: #d1d5db;
              transform: translateX(-50%);
            }
            .org-children::after {
              content: "";
              position: absolute;
              top: 16px;
              left: 16px;
              right: 16px;
              border-top: 1px solid #d1d5db;
            }
            .org-children > .org-node {
              position: relative;
              padding-top: 16px;
            }
            .org-children > .org-node::before {
              content: "";
              position: absolute;
              top: 0;
              left: 50%;
              width: 1px;
              height: 16px;
              background: #d1d5db;
              transform: translateX(-50%);
            }
            .org-children.vertical {
              flex-direction: column;
              align-items: center;
              gap: 12px;
              padding: 12px 0 0 0;
              margin-top: 12px;
              overflow-x: visible;
            }
            .org-children.vertical::before,
            .org-children.vertical::after,
            .org-children.vertical > .org-node::before {
              display: none;
            }
            .org-controls {
              display: inline-flex;
              gap: 8px;
              margin-bottom: 10px;
              justify-content: center;
              width: 100%;
            }
            .org-controls button {
              padding: 6px 10px;
              border-radius: 8px;
              font-size: 12px;
              font-weight: 600;
              cursor: pointer;
            }
          `}</style>
          <div
            ref={zoomContainerRef}
            style={{
              overflow: "auto",
              minHeight: "200px",
              position: "relative",
              width: "100%",
              height: "600px",
              WebkitOverflowScrolling: "touch",
            }}
          >
            <div
              ref={chartContainerRef}
              style={{
                transform: `scale(${zoomLevel})`,
                transformOrigin: "top left",
                transition: "transform 0.2s ease",
                padding: "20px",
                minWidth: "max-content",
                width: "max-content",
                display: "inline-block",
              }}
            >
            <div className="org-controls" style={{ position: "sticky", top: "8px", left: 0, zIndex: 10, marginBottom: "8px", display: "flex", gap: "8px", alignItems: "center", flexWrap: "wrap" }}>
              <button
                type="button"
                onClick={() => setOrgDirection("horizontal")}
                style={{
                  border: orgDirection === "horizontal" ? "1px solid #d3001a" : "1px solid #e5e7eb",
                  background: orgDirection === "horizontal" ? "#fff1f2" : "#ffffff",
                  color: orgDirection === "horizontal" ? "#b91c1c" : "#374151",
                  padding: "6px 10px",
                  borderRadius: "8px",
                  fontSize: "12px",
                  fontWeight: 600,
                  cursor: "pointer",
                }}
              >
                Horizontal
              </button>
              <button
                type="button"
                onClick={() => setOrgDirection("vertical")}
                style={{
                  border: orgDirection === "vertical" ? "1px solid #d3001a" : "1px solid #e5e7eb",
                  background: orgDirection === "vertical" ? "#fff1f2" : "#ffffff",
                  color: orgDirection === "vertical" ? "#b91c1c" : "#374151",
                  padding: "6px 10px",
                  borderRadius: "8px",
                  fontSize: "12px",
                  fontWeight: 600,
                  cursor: "pointer",
                }}
              >
                Vertical
              </button>
              <div style={{ width: "1px", height: "20px", background: "#e5e7eb", margin: "0 4px" }}></div>
              <button
                type="button"
                onClick={() => setZoomLevel((prev) => Math.min(prev + 0.1, 2))}
                disabled={zoomLevel >= 2}
                style={{
                  padding: isMobile ? "6px" : "6px 10px",
                  borderRadius: "8px",
                  border: "1px solid #e5e7eb",
                  background: zoomLevel >= 2 ? "#f3f4f6" : "#ffffff",
                  color: zoomLevel >= 2 ? "#9ca3af" : "#374151",
                  fontSize: "12px",
                  fontWeight: 600,
                  cursor: zoomLevel >= 2 ? "not-allowed" : "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: isMobile ? "0" : "4px",
                  minWidth: isMobile ? "32px" : "auto",
                  justifyContent: "center",
                }}
                title="Zoom In"
              >
                <i className="las la-search-plus" style={{ fontSize: isMobile ? "16px" : "14px" }}></i>
                {!isMobile && <span style={{ marginLeft: "4px" }}>Zoom In</span>}
              </button>
              <button
                type="button"
                onClick={() => setZoomLevel((prev) => Math.max(prev - 0.1, 0.5))}
                disabled={zoomLevel <= 0.5}
                style={{
                  padding: isMobile ? "6px" : "6px 10px",
                  borderRadius: "8px",
                  border: "1px solid #e5e7eb",
                  background: zoomLevel <= 0.5 ? "#f3f4f6" : "#ffffff",
                  color: zoomLevel <= 0.5 ? "#9ca3af" : "#374151",
                  fontSize: "12px",
                  fontWeight: 600,
                  cursor: zoomLevel <= 0.5 ? "not-allowed" : "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: isMobile ? "0" : "4px",
                  minWidth: isMobile ? "32px" : "auto",
                  justifyContent: "center",
                }}
                title="Zoom Out"
              >
                <i className="las la-search-minus" style={{ fontSize: isMobile ? "16px" : "14px" }}></i>
                {!isMobile && <span style={{ marginLeft: "4px" }}>Zoom Out</span>}
              </button>
              <button
                type="button"
                onClick={() => setZoomLevel(1)}
                disabled={zoomLevel === 1}
                style={{
                  padding: isMobile ? "6px" : "6px 10px",
                  borderRadius: "8px",
                  border: "1px solid #e5e7eb",
                  background: zoomLevel === 1 ? "#f3f4f6" : "#ffffff",
                  color: zoomLevel === 1 ? "#9ca3af" : "#374151",
                  fontSize: "12px",
                  fontWeight: 600,
                  cursor: zoomLevel === 1 ? "not-allowed" : "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: isMobile ? "0" : "4px",
                  minWidth: isMobile ? "32px" : "auto",
                  justifyContent: "center",
                }}
                title="Reset Zoom"
              >
                <i className="las la-compress" style={{ fontSize: isMobile ? "16px" : "14px" }}></i>
                {!isMobile && <span style={{ marginLeft: "4px" }}>Reset</span>}
              </button>
              {!isMobile && (
                <span style={{ fontSize: "12px", color: "#6b7280", marginLeft: "4px" }}>
                  {Math.round(zoomLevel * 100)}%
                </span>
              )}
            </div>
            {orgChartLoading ? (
              <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "180px" }}>
                <div className="spinner-border text-primary" role="status"></div>
              </div>
            ) : displayChartData ? (
              <div
                ref={rootNodeRef}
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  width: "max-content",
                  padding: "0 8px 8px 0",
                }}
              >
                <OrgChartNode node={displayChartData} direction={orgDirection} />
              </div>
            ) : (
              <div
                style={{
                  padding: "32px 16px",
                  textAlign: "center",
                  color: "#9ca3af",
                }}
              >
                <i className="las la-sitemap" style={{ fontSize: "36px", marginBottom: "8px", display: "block" }}></i>
                <div style={{ fontSize: "14px" }}>No org chart data available</div>
              </div>
            )}
            </div>
          </div>
        </div>
        )}
        
        <EmployeeAssets userData={userData}/>

        <EmployeeLeave userData={userData}/>

        <div
        className="tab-pane fade" id="emp_documents"
          // id="emp_documents"
          // className="pro-overview tab-pane fade show active"
          style={{ padding: isMobile ? "8px 0 160px 0" : "12px 0 80px 0" }}
        >
          <EmpDocuments userData={userData}/>

        </div>
        <div
          id="emp_expenses"
          className="tab-pane fade"
          style={{ padding: isMobile ? "8px 0 160px 0" : "12px 0 80px 0" }}
        >
          <EmpExpenses userData={userData}/>
        </div>
        <div
          id="emp_uniforms"
          className="tab-pane fade"
          style={{ padding: isMobile ? "8px 0 160px 0" : "12px 0 80px 0" }}
        >
          <EmpUniforms userData={userData}/>
        </div>
        <div
          id="account_settings"
          className="tab-pane fade"
          style={{ padding: isMobile ? "8px 0 160px 0" : "12px 0 80px 0" }}
        >
          <AccountSettings userData={userData}/>
        </div>
        {/*  Bank Tab */}
      </div>
      {/* Model Popup*/}
      <PersonalInformationModelPopup />

      <PersonalInfoModal 
       infoModal={personalInfoModal}
       setInfoModal={setPersonalInfoModal}
       selectedInfo={userData}
       fetchInfo={fetchDetail}
      />

      <AddressModal fetchAddresses={fetchAddresses} userData={userData} addressModal={addressModal} setAddressModal={setAddressModal} selectedAddress={selectedAddress} setSelectedAddress={setSelectedAddress} />
      <DeleteModal
        deleteModal={deleteModal}
        setDeleteModal={setDeleteModal}
        deleteHandler={deleteAddress}
        Name="Delete Emergency Contact"
      />
    </>
  );
};

export default ProfileTab;
